export enum ActionsFetchReducer {
  REQUEST_INIT = 'REQUEST_INIT',
  REQUEST_SUCCESS = 'REQUEST_SUCCESS',
  REQUEST_ERROR = 'REQUEST_ERROR',
  REQUEST_ERROR_ABORT = 'REQUEST_ERROR_ABORT',
}
